module.exports = __webpack_public_path__ + "img/login.70a1dd05.png";